module.exports = {
  "calendar": "Kalendar",
  "day": "\u0434\u0430\u043D",
  "dayPeriod": "\u043F\u0440\u0435 \u043F\u043E\u0434\u043D\u0435/\u043F\u043E \u043F\u043E\u0434\u043D\u0435",
  "endDate": "Datum zavr\u0161etka",
  "era": "\u0435\u0440\u0430",
  "hour": "\u0441\u0430\u0442",
  "minute": "\u043C\u0438\u043D\u0443\u0442",
  "month": "\u043C\u0435\u0441\u0435\u0446",
  "second": "\u0441\u0435\u043A\u0443\u043D\u0434",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Izabrani datum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Izabrani opseg: od ".concat(args.startDate, " do ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Izabrano vreme: ".concat(args.time);
  },
  "startDate": "Datum po\u010Detka",
  "timeZoneName": "\u0432\u0440\u0435\u043C\u0435\u043D\u0441\u043A\u0430 \u0437\u043E\u043D\u0430",
  "weekday": "\u0434\u0430\u043D \u0443 \u043D\u0435\u0434\u0435\u0459\u0438",
  "year": "\u0433\u043E\u0434\u0438\u043D\u0430"
};